import { render } from "./CouponItem.vue?vue&type=template&id=6fbd1a4a&scoped=true"
import script from "./CouponItem.vue?vue&type=script&lang=js"
export * from "./CouponItem.vue?vue&type=script&lang=js"

import "./CouponItem.vue?vue&type=style&index=0&id=6fbd1a4a&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbd1a4a"]])

export default __exports__